const ISSUE_SERVICES = [
  "assembla",
  "bitbucket",
  "github",
  "gitlab",
  "jira",
  "lighthouse",
  "pivotalTracker",
  "trello",
];
const CHAT_SERVICES = ["campfire", "flowdock", "slack"];

export class Services {
  public static ISSUE = ISSUE_SERVICES;
  public static CHAT = CHAT_SERVICES;
}
